/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.variant = this.getSelectedVariant();
      this.selectedOptions = this.getSelectedOptions();
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;
      this.addEventListener('change', this.handleVariantChange.bind(this));

      // Defer these to allow for quick-add modal to full initialize
      setTimeout(() => {
        this.updateAvailability();
        this.updateAddToCartButton();
      });
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateMobilePrice();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateMetafieldVisibility();
      VariantPicker.updateLabelText(evt);

      if (!this.preSelection) {
        this.dispatchEvent(new CustomEvent('on:variant:change', {
          bubbles: true,
          detail: {
            form: this.productForm,
            variant: this.variant,
            product: this.data.product
          }
        }));
      }
    }

    /**
     * Shows/hides variant metafield elements on the page as necessary
     */
    updateMetafieldVisibility() {
      document.querySelectorAll('[data-variant-metafield]').forEach((elem) => {
        elem.classList.toggle('hidden', elem.dataset.variantMetafield !== this.variant?.id.toString());
      });
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */

    // updateAddToCartButton() {
    //   this.productForm = this.section.querySelector('.js-product-form-main');
    //   if (!this.productForm) return;

    //   this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
    //   const variantAvailable = this.variant && this.variant.available;

    //   this.addBtn.disabled = !variantAvailable || this.preSelection;

    //   if (this.preSelection) {
    //     this.addBtn.textContent = theme.strings.noSelectedVariant;
    //   } else {

    //     const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
    //     this.addBtn.textContent = variantAvailable
    //       ? this.addBtn.dataset.addToCartText
    //       : unavailableStr;
    //   }

    // }

    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form-main');
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;

      this.addBtn.disabled = !variantAvailable || this.preSelection;

      if (this.preSelection) {
        this.addBtn.textContent = theme.strings.noSelectedVariant;
      } else {
        const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;

        // Set the button base text (Add to Cart / Preorder / Sold Out)
        this.addBtn.textContent = variantAvailable
          ? this.addBtn.dataset.addToCartText
          : unavailableStr;

        // --- Append price span ---
        if (variantAvailable && this.data?.formatted?.[this.variant.id]?.price) {
          const priceSpan = document.createElement('span');
          priceSpan.className = 'show_prc_atc_btn';
          priceSpan.innerHTML = ` - ${this.data.formatted[this.variant.id].price}`;

          this.addBtn.appendChild(priceSpan);
        }
      }
    }


    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      const { availabilityMethod } = this.dataset; // 'downward' or 'selection'
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.selectedOptions };
      }

      if(currVariant && currVariant.sku){
        this.updateEDD(currVariant.sku, currVariant);
        this.updateStockMessage(currVariant.sku);
      }

      if (availabilityMethod === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.product.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.product.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
        });
      }
    }


    // based on SKU show EDD message
    // formatDate(dateStr) {
    //   const d = new Date(dateStr);
    //   const day = d.getDate();

    //   // Determine suffix
    //   const suffix =
    //     day % 10 === 1 && day !== 11 ? "st" :
    //     day % 10 === 2 && day !== 12 ? "nd" :
    //     day % 10 === 3 && day !== 13 ? "rd" : "th";

    //   // Always return exactly 3-letter month
    //   const month = d.toLocaleString('en-US', { month: 'short' }).slice(0, 3);

    //   return `${day}${suffix} ${month}`;
    // }

    
    // updateEDD(sku) {
    //   const eddBox = document.getElementById("edd-message");
    //   const eddMobBox = document.getElementById("edd-messageMob");
    //   const parentBoxes = document.querySelectorAll(".api_edd_msg"); // parent wrapper
    //   parentBoxes.forEach(parentBox => {
    //     parentBox.classList.add("hidden");
    //   });
    //   if (!eddMobBox) return;
    //   if (!eddBox) return;
    //   if (!sku) return;
    //   fetch(`https://api.trampolinestore.uk/fableroom/edd/?format=json&sku=${sku}`)
    //     .then(res => res.json())
    //     .then(data => {
    //       // 🚫 Skip if API returns error
    //       if (data.error) {
    //         console.warn(`EDDV skipped for SKU ${sku}: ${data.error}`);
    //         // return "";
    //         parentBoxes.forEach(parentBox => {
    //           parentBox.classList.add("hidden");
    //         });

    //       }

    //       console.log(data,"here vvvvpicker");
    //       let message = "";
    //       if (data.message) {
    //         message = data.message;
    //       } else if (data.min_edd && data.max_edd) {
    //         const minDate = this.formatDate(data.min_edd);
    //         const maxDate = this.formatDate(data.max_edd);
    //         message = `Delivery between ${minDate} to ${maxDate}`;
    //       }
    //       parentBoxes.forEach(parentBox => {
    //         if (message) {
    //           parentBox.classList.remove("hidden"); 
    //           eddBox.textContent = message;
    //           eddMobBox.textContent = message;
    //           const divElement = document.querySelector('#shipping-msg');
    //           if (divElement) {
    //             divElement.value = message;
    //           }
    //         
    //         } else {
    //           parentBox.classList.add("hidden");   // hide if no message
    //         }
    //       });
         
    //     })
    //     .catch(err => console.error("EDD API Error:", err));
    // }

    // new api 
    // new api 
    // new api 
    updateEDD(sku, currentVar) {
      const eddBox = document.getElementById("edd-message");
      const parentBoxes = document.querySelectorAll(".api_edd_msg");
      // const freeDeliveryEl = document.querySelector('.free_delivry_txt');
      const infoTooltipEl = document.querySelector('.info_tooltip_edd');

      // if (freeDeliveryEl && currentVar) {
      //   const currentVarPrc = currentVar.price;

      //   const FREE_DELIVERY_THRESHOLD = 10000; // in cents

      //   if (currentVarPrc > FREE_DELIVERY_THRESHOLD) {
      //     freeDeliveryEl.classList.remove('hidden');
      //     freeDeliveryEl.textContent = 'Free Delivery';
      //   } else {
      //     freeDeliveryEl.classList.add('hidden'); // keep visible
      //     freeDeliveryEl.textContent = 'Free Delivery Over £100';
      //   }
      // }

      this.checkExpressMetaVal(currentVar);


      // Hide initially
      parentBoxes.forEach(parentBox => {
        parentBox.classList.add("hidden");
      });

      if (!eddBox || !sku) return;

      const countryCode = window?.Shopify?.country;

      // const apiUrl =
      // countryCode === "DE"
      //   ? `https://api.trampolinestore.uk/fableroom/de/edd/?format=json&sku=${sku}`
      //   : `https://api.trampolinestore.uk/fableroom/edd/?format=json&sku=${sku}`;

      const apiUrl =`https://api.trampolinestore.uk/fableroom/edd/?format=json&sku=${sku}`;
        
      fetch(apiUrl)
        .then(res => res.json())
        .then(data => {

          console.log(data, "Variant PDP EDD response");

          // ❗ If API error → hide everything
          if (data.error) {
            console.warn(`EDD skipped for SKU ${sku}: ${data.error}`);
            parentBoxes.forEach(parentBox => parentBox.classList.add("hidden"));
            this.checkExpressMetaVal(currentVar);
            return;
          }

          if (infoTooltipEl) {
            if (data.is_preorder) {
              infoTooltipEl.classList.remove("hidden");
            } else {
              infoTooltipEl.classList.add("hidden");
            }
          }

          // ✅ PRIORITY LOGIC (dynamic)
          let message = "";

          if (data.message) {
            message = data.message.trim();
          } else if (data.shipping_message) {
            message = data.shipping_message.trim();
          }

          parentBoxes.forEach(parentBox => {
            if (message) {
              // ✅ Show message
              parentBox.classList.remove("hidden");

              eddBox.textContent = message;

              // ✅ Update hidden inputs (used for cart)
              const divElement = document.querySelector('#shipping-msg');
              if (divElement) {
                divElement.value = message;
              }


            } else {
              // ❗ Clear old message if API returns blank
              parentBox.classList.add("hidden");

              eddBox.textContent = "";

              const divElement = document.querySelector('#shipping-msg');
              if (divElement) {
                divElement.value = "";
              }

             
            }
          });
          this.checkExpressMetaVal(currentVar);

        })
        .catch(err => {
          console.error("EDD API Error:", err);

          // ❗ On error also clear
          parentBoxes.forEach(parentBox => parentBox.classList.add("hidden"));

          if (eddBox) eddBox.textContent = "";
          this.checkExpressMetaVal(currentVar);
        });
    }
    // new api 
    // new api 
    // new api 

    // checkExpressMetaVal(currentVar) {
    //   const parentBoxes = document.querySelectorAll(".api_edd_msg");
    //   const metafieldJsonEl = document.getElementById('VariantMetafieldsJson-delivery_days');

    //   if (!metafieldJsonEl) {
    //     console.warn('VariantMetafieldsJson-delivery_days not found');
    //     return;
    //   }

    //   let variantMetafields = {};

    //   try {
    //     variantMetafields = JSON.parse(metafieldJsonEl.textContent);
    //   } catch (e) {
    //     console.error('Variant metafield JSON parse error:', e);
    //     return;
    //   }

    //   const variantId = String(currentVar?.id || '');

    //   console.log('Current Variant Object:', currentVar);
    //   console.log('Selected Variant ID:', variantId);
    //   console.log('Available metafield IDs:', Object.keys(variantMetafields));

    //   const deliveryDays = variantMetafields?.[variantId]?.delivery_type;

    //   console.log('Delivery Days Metafield:', deliveryDays);

    //   const hasDeliveryDays =
    //     deliveryDays !== null &&
    //     deliveryDays !== undefined &&
    //     deliveryDays !== '';

    //   parentBoxes.forEach(parentBox => {
    //     if (hasDeliveryDays) {
    //       parentBox.classList.add("express-hidden");
    //     } else {
    //       parentBox.classList.remove("express-hidden");
    //     }
    //   });
    // }

    checkExpressMetaVal(currentVar) {
      const parentBoxes = document.querySelectorAll(".api_edd_msg");
      const metafieldJsonEl = document.getElementById('VariantMetafieldsJson-delivery_days');

      if (!metafieldJsonEl) {
        console.warn('VariantMetafieldsJson-delivery_days not found');
        return;
      }

      let variantMetafields = {};

      try {
        variantMetafields = JSON.parse(metafieldJsonEl.textContent);
      } catch (e) {
        console.error('Variant metafield JSON parse error:', e);
        return;
      }

      const variantId = String(currentVar?.id || '');
      const deliveryDays = Number(variantMetafields?.[variantId]?.delivery_type);

      console.log('Delivery Days Metafield:', deliveryDays);

      const hasExpressDelivery = deliveryDays === 3 || deliveryDays === 4;

      parentBoxes.forEach(parentBox => {
        if (hasExpressDelivery) {
          parentBox.classList.add("express-hidden");
        } else {
          parentBox.classList.remove("express-hidden");
        }
      });
    }

    async updateStockMessage(sku) {
      if (!sku) {
        hideStockMessage();
        return;
      }

      try {
        const countryCode = window?.Shopify?.country;
        // const apiUrl =
        // countryCode === "DE"
        //   ? `https://api.trampolinestore.uk/fableroom/de/v2/edd/?format=json&sku=${sku}`
        //   : `https://api.trampolinestore.uk/fableroom/v2/edd/?format=json&sku=${sku}`;

        const apiUrl =`https://api.trampolinestore.uk/fableroom/v2/edd/?format=json&sku=${sku}`;
        
        const res = await fetch(apiUrl);
        const data = await res.json();

        if (!Array.isArray(data) || !data.length) {
          console.warn(`No stock data for SKU: ${sku}`);
          hideStockMessage();
          return;
        }

        // 👉 Take only first object from API response
        const firstItem = data[0];
        const availableQty = firstItem?.available_quantity;
        console.log(firstItem, "firstItem");
        this.handleStockMessage(availableQty);

      } catch (err) {
        console.error("Stock API Error:", err);
        this.hideStockMessage();
      }
    }

    handleStockMessage(availableQty) {
      console.log(availableQty, "availableQty");
      const wrapper = document.querySelector('.stock_message_strip_wrp');
      const qtySpan = document.querySelector('.stock_msg_info span');
      const msgInfo = document.querySelector('.stock_msg_info');
      const lineItemStockMsg = document.querySelector('#low_stock_message');
      const isGerman = window?.Shopify?.country === 'DE';
      
      if (!wrapper || !qtySpan || !msgInfo) return;

      if (typeof availableQty === 'number' && availableQty < 5) {
        // const unitText = isGerman
        // ? 'Stück'
        // : (availableQty === 1 ? 'Unit' : 'Units');
        const unitText = availableQty === 1 ? 'Unit' : 'Units';
        qtySpan.textContent = `${availableQty} ${unitText}`;
        lineItemStockMsg.value = `${availableQty} ${unitText}`;
        wrapper.style.display = 'block';
      } else {
        wrapper.style.display = 'none';
        lineItemStockMsg.value = "";
      }
    }

    hideStockMessage() {
      const wrapper = document.querySelector('.stock_message_strip_wrp');
      if (wrapper) wrapper.style.display = 'none';
    }


    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */

    // updatePrice() {
    //   this.price = this.price || this.section.querySelector('.product-info__price > .price');
    //   if (!this.price) return;

    //   let { variant } = this;
    //   if (this.preSelection) {
    //     variant = this.data.product.variants[0];
       
    //     for (let i = 1; i < this.data.product.variants.length; i += 1) {
    //       if (this.data.product.variants[i].price < variant.price) variant = this.data.product.variants[i];
    //     }
    //   }
    //    console.log("varrr", this.variant);

    //   if (this.variant) {
    //     const varCompareAtPrice = variant.compare_at_price; // e.g., 27700
    //     const varPrice = variant.price; // e.g., 19900
    //     const priceCurrentEl = this.price.querySelector('.price__current');
    //     const priceWasEl = this.price.querySelector('.price__was');
    //     const tmpTxt = this.price.querySelector('.tmp_txt');
    //     const unitPriceEl = this.price.querySelector('.unit-price');
    //     const savedPercentageEl = this.price.querySelector('.saved_text span');
    //     const newTempPDP = document.querySelector('.new_pdp_budge span');
    //     console.log(newTempPDP);
    //     let selectedVariantId = variant.id;
    //     let metafieldValue = window.variantMetafields[selectedVariantId]?.custom_cprice;
    //     let metafieldValueWithoutFormate = Number(window.variantMetafields[selectedVariantId]?.custom_cprice_without_formate.replace(/,/g, ''));
    //     console.log("metafieldValueWithoutFormate:", metafieldValueWithoutFormate, typeof metafieldValueWithoutFormate);
    //     console.log("varCompareAtPrice:", varCompareAtPrice, typeof varCompareAtPrice);
    //     if(savedPercentageEl){
    //       if(varCompareAtPrice == null){
    //         var cprc = varPrice;
    //       }else{
    //         var cprc = varCompareAtPrice;
    //       }
    //     }
    //     if(newTempPDP){
    //       var cprc = varPrice;
    //     }
        

    //     // document.getElementById("metafieldDisplay").innerText = metafieldValue || 'No metafield data';
        
    //     // Update current price and original price if on sale.
    //     priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
    //     if (priceWasEl)
    //       // compare price from metafileds custom code
    //       // priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';
    //       priceWasEl.innerHTML = metafieldValue || '';
    //       if(tmpTxt && metafieldValue){
    //         tmpTxt.style.display= 'block';
    //       }else {
    //         tmpTxt.style.display= 'none';
    //       }
        
    //       // custom code saved percentage price
    //        const discountBlock = document.querySelector('.best_prc_acrdion .calc_dicounted_prc');
    //       if (varCompareAtPrice) {
    //         // custom sale price
    //         priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice;
    //           if (discountBlock) {
    //             discountBlock.innerHTML = this.data.formatted[this.variant.id].price; 
    //           }
    //           discountBlock.style.display= 'inline-flex';
    //       }else {
    //         discountBlock.style.display= 'none';
    //       }
    //     if(metafieldValueWithoutFormate){
    //       console.log(metafieldValueWithoutFormate);
    //       console.log(cprc);
    //        const savedPercentage = ((metafieldValueWithoutFormate - cprc) / metafieldValueWithoutFormate) * 100;
    //        const roundedPercentage = Math.round(savedPercentage); // Or use toFixed(2) if you want decimals
    //       console.log(roundedPercentage);
    //       if(savedPercentageEl){
    //        savedPercentageEl.innerHTML = `${roundedPercentage}`;
    //       }
    //       if(newTempPDP){
    //          newTempPDP.innerHTML = `${roundedPercentage}`;
    //       }
    //     }else {
    //       if(savedPercentageEl){
    //         savedPercentageEl.innerHTML = "";
    //       }
    //       if(newTempPDP){
    //          newTempPDP.innerHTML = "";
    //       }
    //     }

    //     // Update unit price, if specified.
    //     if (this.variant.unit_price_measurement) {
    //       const valueEl = this.price.querySelector('.unit-price__price');
    //       const unitEl = this.price.querySelector('.unit-price__unit');
    //       const value = this.variant.unit_price_measurement.reference_value;
    //       const unit = this.variant.unit_price_measurement.reference_unit;

    //       valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
    //       unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
    //     }

    //     unitPriceEl.hidden = !this.variant.unit_price_measurement;
    //     this.price.classList.toggle(
    //       'price--on-sale',
    //       this.variant.compare_at_price > this.variant.price
    //     );
    //     this.price.classList.toggle('price--sold-out', !this.variant.available && !this.preSelection);
        
    //   }

    //   this.price.querySelector('.price__default').hidden = !this.variant && !this.preSelection;
    //   this.price.querySelector('.price__no-variant').hidden = this.variant || this.preSelection;
    //   const from = this.price.querySelector('.price__from');
    //   if (from) {
    //     from.hidden = !this.preSelection;
    //   }
    // }


    updatePrice() {
      this.price = this.section.querySelector('.desktop-product-price .product-info__price > .price') || this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      let { variant } = this;
      if (this.preSelection) {
        variant = this.data.product.variants[0];
       
        for (let i = 1; i < this.data.product.variants.length; i += 1) {
          if (this.data.product.variants[i].price < variant.price) variant = this.data.product.variants[i];
        }
      }
       // console.log("varrr", this.variant);
       this.lineItemPropertyChange(this.variant, this.data.formatted[this.variant.id]);

      if (this.variant) {
        const varCompareAtPrice = variant.compare_at_price; // e.g., 27700
        const varPrice = variant.price; // e.g., 19900
        const priceCurrentEl = this.price.querySelector('.price__current');
        const stickyBtn = document.querySelector('.sticky-atc-btn');
        const stickyPrice = stickyBtn?.querySelector('.show_prc_atc_btn');
        const stickyText = stickyBtn?.querySelector('.sticky_text');
        
       
        // console.log(priceCurrentEl);
        const priceWasEl = this.price.querySelector('.price__was');
        const tmpTxt = this.price.querySelector('.tmp_txt');
        const unitPriceEl = this.price.querySelector('.unit-price');
        const savedPercentageEl = this.price.querySelector('.saved_text.desk_save span');
        const newTempPDP = document.querySelector('.new_pdp_budge span');
        // console.log(newTempPDP);
        let selectedVariantId = variant.id;
        
        const priceContainer = document.querySelector('.price[data-variant-metafields]');
        if (priceContainer) {
          try {
            const metafieldsJSON = priceContainer.dataset.variantMetafields;
            if (metafieldsJSON) {
              window.variantMetafields = JSON.parse(metafieldsJSON);
            }
          } catch (error) {
            console.error('Failed to parse variant metafields:', error);
          }
        }
        
        let metafieldValue = window.variantMetafields[selectedVariantId]?.custom_cprice;
        let metafieldValueWithoutFormate = Number(window.variantMetafields[selectedVariantId]?.custom_cprice_without_formate.replace(/,/g, ''));
        // console.log("metafieldValueWithoutFormate:", metafieldValueWithoutFormate, typeof metafieldValueWithoutFormate);
        // console.log("varCompareAtPrice:", varCompareAtPrice, typeof varCompareAtPrice);
        if(savedPercentageEl){
          if(varCompareAtPrice == null){
            var cprc = varPrice;
          }else{
            var cprc = varCompareAtPrice;
          }
        }
        if(newTempPDP){
          var cprc = varPrice;
        }
        

        // document.getElementById("metafieldDisplay").innerText = metafieldValue || 'No metafield data';
        
        // Update current price and original price if on sale.
        priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
       

        if (stickyBtn && stickyPrice && this.variant) {
          const variantAvailable = this.variant.available;
          const variantPrice = this.data.formatted[this.variant.id]?.price;

          // Update price
          if (variantPrice) {
            stickyPrice.innerHTML = variantPrice;
          }

          // Handle availability
          if (!variantAvailable) {
            stickyBtn.classList.add('disable');
            stickyBtn.setAttribute('disabled', 'true');
            stickyText.textContent = 'Sold Out';
          } else {
            stickyBtn.classList.remove('disable');
            stickyBtn.removeAttribute('disabled');
            stickyText.textContent = theme.strings.addToCart || 'Add to cart';
          }
        }

         
        
        if (priceWasEl)
          // compare price from metafileds custom code
          // priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';
          if (metafieldValue) {
            let formattedValue = metafieldValue;
            // Remove .00 only if it exists at the end
            formattedValue = formattedValue.replace(/\.00$/, '');

            priceWasEl.innerHTML = formattedValue;
          } else {
            priceWasEl.innerHTML = '';
          }
          if(tmpTxt && metafieldValue){
            tmpTxt.style.display= 'block';
          }else {
            tmpTxt.style.display= 'none';
          }
        
          // custom code saved percentage price
           const discountBlock = document.querySelector('.product-info__discount_tags .best_prc_acrdion.mobile_hide .calc_dicounted_prc');
           const savedPercentageElDouble = document.querySelector('.product-info__discount_tags .best_prc_acrdion.mobile_hide .desk_doubled span');
           const discountBlockParent = document.querySelector('.product-info__discount_tags .best_prc_acrdion.mobile_hide');
        // console.log(discountBlock, "discountBlock");
          if (varCompareAtPrice) {
            // custom sale price
             priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice;
            // priceCurrentEls.forEach((el) => {
            //   el.innerHTML = this.data.formatted[this.variant.id].compareAtPrice;
            // });
              if (discountBlock) {
                discountBlock.innerHTML = this.data.formatted[this.variant.id].price; 
              }
              discountBlock.style.display= 'inline-flex';
              discountBlockParent.style.display= 'block';
          }else {
            discountBlock.style.display= 'none';
            discountBlockParent.style.display= 'none';
          }
        if(metafieldValueWithoutFormate){
          // console.log(metafieldValueWithoutFormate);
          // console.log(cprc);
           const savedPercentage = ((metafieldValueWithoutFormate - varPrice) / metafieldValueWithoutFormate) * 100;
          //  const savedPercentage = ((metafieldValueWithoutFormate - cprc) / metafieldValueWithoutFormate) * 100;
           const roundedPercentage = Math.round(savedPercentage); // Or use toFixed(2) if you want decimals
          // console.log(roundedPercentage);
          if(savedPercentageEl){
           savedPercentageEl.innerHTML = `${roundedPercentage}`;
           if(savedPercentageElDouble){
             savedPercentageElDouble.innerHTML = `${roundedPercentage}`;
           }
          }
          if(newTempPDP){
             newTempPDP.innerHTML = `${roundedPercentage}`;
          }
        }else {
          if(savedPercentageEl){
            savedPercentageEl.innerHTML = "";
          }
          if(newTempPDP){
             newTempPDP.innerHTML = "";
          }
        }

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available && !this.preSelection);
        
      }

      this.price.querySelector('.price__default').hidden = !this.variant && !this.preSelection;
      this.price.querySelector('.price__no-variant').hidden = this.variant || this.preSelection;
      const from = this.price.querySelector('.price__from');
      if (from) {
        from.hidden = !this.preSelection;
      }
    }
    
    updateMobilePrice() {
      this.price = this.section.querySelector('.upper_content_mobile_only .mobile_show .product-info__price > .price');
      if (!this.price) return;
      // console.log(this.price);

      let { variant } = this;
      if (this.preSelection) {
        variant = this.data.product.variants[0];
       
        for (let i = 1; i < this.data.product.variants.length; i += 1) {
          if (this.data.product.variants[i].price < variant.price) variant = this.data.product.variants[i];
        }
      }
       // console.log("varrr", this.variant);

      if (this.variant) {
        const varCompareAtPrice = variant.compare_at_price; // e.g., 27700
        const varPrice = variant.price; // e.g., 19900
       
        const priceCurrentEl = this.price.querySelector('.price__current');
        
        const priceWasEl = this.price.querySelector('.price__was');
        const tmpTxt = this.price.querySelector('.tmp_txt');
        const unitPriceEl = this.price.querySelector('.unit-price');
        const savedPercentageEl = this.price.querySelector('.saved_text span');
        const newTempPDP = document.querySelector('.new_pdp_budge span');
        // console.log(newTempPDP);
        let selectedVariantId = variant.id;
        let metafieldValue = window.variantMetafields[selectedVariantId]?.custom_cprice;
        let metafieldValueWithoutFormate = Number(window.variantMetafields[selectedVariantId]?.custom_cprice_without_formate.replace(/,/g, ''));
        // console.log("metafieldValueWithoutFormate:", metafieldValueWithoutFormate, typeof metafieldValueWithoutFormate);
        // console.log("varCompareAtPrice:", varCompareAtPrice, typeof varCompareAtPrice);
        if(savedPercentageEl){
          if(varCompareAtPrice == null){
            var cprc = varPrice;
          }else{
            var cprc = varCompareAtPrice;
          }
        }
        if(newTempPDP){
          var cprc = varPrice;
        }
        
        // document.getElementById("metafieldDisplay").innerText = metafieldValue || 'No metafield data';
        
        // Update current price and original price if on sale.
        priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
        if (priceWasEl)
          // compare price from metafileds custom code
          // priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';
          if (metafieldValue) {
            let formattedValue = metafieldValue;
            // Remove .00 only if it exists at the end
            formattedValue = formattedValue.replace(/\.00$/, '');

            priceWasEl.innerHTML = formattedValue;
          } else {
            priceWasEl.innerHTML = '';
          }
          if(tmpTxt && metafieldValue){
            tmpTxt.style.display= 'block';
          }else {
            tmpTxt.style.display= 'none';
          }
        
          // custom code saved percentage price
           const discountBlock = document.querySelector('.best_prc_acrdion .calc_dicounted_prc');
           const discountBlockPar = document.querySelector('.best_prc_acrdion.mob_dv_only_ofr');
           const prcSelector = document.querySelector('.mob_prcc.price__current');
          if (varCompareAtPrice) {
            // custom sale price
            priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice;
              if (discountBlock) {
                discountBlock.innerHTML = this.data.formatted[this.variant.id].price; 
              }
              discountBlock.style.display= 'inline-flex';
              discountBlockPar.style.display= 'inline-flex';
              prcSelector.classList.add('line_on_txt');
              
          }else {
            discountBlock.style.display= 'none';
            discountBlockPar.style.display= 'none';
            prcSelector.classList.remove('line_on_txt');
          }
        if(metafieldValueWithoutFormate){
          // console.log(metafieldValueWithoutFormate);
          // console.log(cprc);
           const savedPercentage = ((metafieldValueWithoutFormate - varPrice) / metafieldValueWithoutFormate) * 100;
          //  const savedPercentage = ((metafieldValueWithoutFormate - cprc) / metafieldValueWithoutFormate) * 100;
           const roundedPercentage = Math.round(savedPercentage); // Or use toFixed(2) if you want decimals
          // console.log(roundedPercentage);
          if(savedPercentageEl){
           savedPercentageEl.innerHTML = `${roundedPercentage}`;
          }
          if(newTempPDP){
             newTempPDP.innerHTML = `${roundedPercentage}`;
          }
        }else {
          if(savedPercentageEl){
            savedPercentageEl.innerHTML = "";
          }
          if(newTempPDP){
             newTempPDP.innerHTML = "";
          }
        }

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available && !this.preSelection);
        
      }

      this.price.querySelector('.price__default').hidden = !this.variant && !this.preSelection;
      this.price.querySelector('.price__no-variant').hidden = this.variant || this.preSelection;
      const from = this.price.querySelector('.price__from');
      if (from) {
        from.hidden = !this.preSelection;
      }
    }


    lineItemPropertyChange(variant, formtVariant){
      // console.log(12, formtVariant.price);
      const discountInput = document.getElementById('discount-info-input');
      if (!variant || !discountInput) return;

      if (variant.compare_at_price > variant.price) {
        const discountPercent = Math.round(
          ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
        );

        discountInput.value = (
          `Original: ${formtVariant.compareAtPrice}, ` +
          `Discounted: ${formtVariant.price}, ` +
          `Discount: ${discountPercent}%`
        ).replace(/[\r\n]+/g, '').trim();
      } else {
        discountInput.value = 'No Discount';
      }
    }

    


    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
      if (this.barcodes.length === 0) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selectedText = selector.querySelector('.custom-select__btn').textContent.trim();
          selectedOptions.push(selectedText === this.dataset.placeholderText ? null : selectedText);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      return this.data.product.variants.find(
        (v) => v.options.every((val, index) => val === selectedOptions[index])
      );
    }
  }

  customElements.define('variant-picker', VariantPicker);
}
